import React from 'react';
import { connect } from 'react-redux';
import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

const _ModalSlot = ({ scenePluginId }: Props) => {
    const plugin = scenePlugins.require(scenePluginId);
    const ModalUi = plugin.ui.modal!;
    return <ModalUi />;
};

type Props = {
    scenePluginId: string;
};

const mapStateToProps = (state: PdpState) => ({
    scenePluginId: state.scene.pluginId
});

export const ModalSlot = connect(
    mapStateToProps
)(_ModalSlot);